<template>
  <v-app id="inspire">
    <!-- 
      로그인 되었을때
    -->
    <div v-if="mallId !== null">
      <v-navigation-drawer
        v-model="drawer"
        :clipped="$vuetify.breakpoint.lgAndUp"
        app
        ref="appNavigation"
      >
        <v-list dense>
          <template v-for="item in items">
            <v-list-item :key="item.text" link>
              <router-link class="navigation-router-link" :to="item.toPath">
                <v-list-item-action>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    <p class="subtitle-2 mb-0">{{ item.text }}</p>
                  </v-list-item-title>
                </v-list-item-content>
              </router-link>
            </v-list-item>
          </template>
        </v-list>
        <BrowerGuide></BrowerGuide>
      </v-navigation-drawer>
      <v-app-bar
        :clipped-left="$vuetify.breakpoint.lgAndUp"
        app
        color="blue darken-3"
        dark
        ref="appBar"
      >
        <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
        <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
          <span class="hidden-sm-and-down">{{ appTitle }}</span>
        </v-toolbar-title>

        <v-spacer />
        <AppVersion ref="AppVersion"></AppVersion>
      </v-app-bar>
      <v-content>
        <v-container class="height" fluid>
          <router-view></router-view>
        </v-container>
      </v-content>
    </div>
    <!-- 
      로그인 안했을때 ( 로그인 페이지 )
    -->
    <div v-else>
      <v-content>
        <v-container>
          <v-row class="justify-center">
            <div class="col-12">
              <Partners ref="Partners"></Partners>
            </div>
          </v-row>
        </v-container>
      </v-content>
    </div>
  </v-app>
</template>

<style scoped>
.navigation-router-link {
  color: unset;
  text-decoration: none;
  width: 100%;
  display: flex;
}
</style>

<script>
import store from "./store";
import M from "@/libs/mapping.js";
import { AUTH_SERVICE } from "@/datas/authservice";
import CommonMixin from "@/mixins/CommonMixin.js";
import BrowerGuide from "@/components/shoplus_service/BrowserGuide.vue";
import AppVersion from "@/components/shoplus_service/version/AppVersion.vue";
import Partners from "@/components/shoplus_service/partners/Partners.vue";

export default {
  data() {
    return {
      M,
      AUTH_SERVICE,
      appTitle: "Shop+ 서비스",
      drawer: null,
      items: [
        {
          icon: "mdi-barcode-scan",
          text: "정품인증서비스",
          toPath: `/shoplus_service/${store.state.mallId}/authservice`,
        },
      ],
      mallId: null,
      urlSplitArray: {},
    };
  },
  methods: {
    setMallId: function() {
      this.mallId = store.state.mallId;
    },
    urlSplit: function() {
      let url = this.$router.app.path;
      let pathArray = url.split("/");
      this.urlSplitArray = pathArray;
    },
  },
  mixins: [CommonMixin],
  components: {
    Partners,
    AppVersion,
    BrowerGuide,
  },
  created: async function() {
    this.setMallId();
    this.urlSplit();
    if (this.mallId) {
      try {
        let result = await M.api(M.entry("/users/info"));
        this.$refs.AppVersion.setInfoParams(result);
      } catch (e) {
        alert("업체 정보 조회에 실패했습니다.");
      }
    }
  },
};
</script>
